import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=df352c62&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=df352c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df352c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df352c62')) {
      api.createRecord('df352c62', component.options)
    } else {
      api.reload('df352c62', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=df352c62&scoped=true&", function () {
      api.rerender('df352c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8vh90A35nQn5U/JS/comp/GuestBox.vue"
export default component.exports